<template>
  <div>
    <div class="page-header">
      <div>
        <div class="page-title">新增进件</div>
        <div class="page-subtitle">填写商户资料与通道信息</div>
      </div>
      <el-button type="primary" plain @click="goBack">返回列表</el-button>
    </div>
    <el-card>
      <el-form label-width="120px">
        <el-form-item label="商户名称" required>
          <el-input v-model="form.name" placeholder="请输入商户名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="企业类型" required>
          <el-input v-model="form.enterpriseType" placeholder="请输入企业类型，0企业" maxlength="1" show-word-limit />
        </el-form-item>
        <el-form-item label="企业名称" required>
          <el-input v-model="form.enterpriseName" placeholder="请输入企业名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="企业简称" required>
          <el-input v-model="form.enterpriseShortName" placeholder="请输入企业简称" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="统一社会信用代码" required>
          <el-input v-model="form.unifiedSocialCreditCode" placeholder="请输入统一社会信用代码" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="营业范围">
          <el-input v-model="form.businessScope" type="textarea" rows="3" placeholder="请输入营业范围" maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="地址选择（营业执照地址）" required>
          <el-cascader
            v-model="selectedRegion"
            :options="regionData"
            :props="{ value: 'value', label: 'label', children: 'children' }"
            placeholder="请选择省市区"
            @change="handleRegionChange"
            style="width: 100%"
          />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            请选择省市区，再输入详细地址
          </div>
        </el-form-item>
        <el-form-item label="地址选择（营业执照地址）" required>
          <el-input v-model="form.address" placeholder="请输入详细地址，不包括省、市、区" maxlength="30" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            详细地址，不包括省、市、区
          </div>
        </el-form-item>
        <el-form-item label="法人姓名" required>
          <el-input v-model="form.legalPersonName" placeholder="请输入法人姓名" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="法人身份证号码" required>
          <el-input v-model="form.legalPersonIdNumber" placeholder="请输入法人身份证号码" maxlength="18" show-word-limit />
        </el-form-item>
        <el-form-item label="法人身份证起始日期" required>
          <el-input v-model="form.legalPersonIdCardStartDate" placeholder="请输入法人身份证起始日期，yyyyMMdd" maxlength="8" show-word-limit />
            <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            格式：yyyyMMdd，例如：20230101
          </div>
        </el-form-item>
        <el-form-item label="法人身份证终止日期" required>
          <el-input v-model="form.legalPersonIdCardEndDate" placeholder="请输入法人身份证终止日期，yyyyMMdd，如果为长期，传20991231" maxlength="8" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            格式：yyyyMMdd，例如：20230101 ，如果为长期，传20991231
          </div>
        </el-form-item>
        <el-form-item label="法人手机号" required>
          <el-input v-model="form.legalPersonMobilePhone" placeholder="请输入法人手机号" maxlength="11" show-word-limit />
        </el-form-item>
        <el-form-item label="商务联系人" required>
          <el-input v-model="form.linkmanName" placeholder="请输入商务联系人姓名" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="联系人手机号" required>
          <el-input v-model="form.linkmanMobilePhone" placeholder="请输入联系人手机号" maxlength="11" show-word-limit />
        </el-form-item>
        <el-form-item label="客服电话" required>
          <el-input v-model="form.customerServicePhone" placeholder="请输入客服电话" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="结算银行" required>
          <el-select v-model="form.bankCode" placeholder="请选择结算银行" style="width: 100%" filterable>
            <el-option
              v-for="bank in bankList"
              :key="bank.value"
              :label="bank.label+'('+bank.value+')'"
              :value="bank.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="结算银行卡类型" required>
          <el-input v-model="form.bankCardType" placeholder="请输入结算银行卡类型，0对公" maxlength="1" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            0：对公银行账户
          </div>
        </el-form-item>
        <el-form-item label="结算账号" required>
          <el-input v-model="form.bankAccount" placeholder="请输入结算账号" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="账户名称" required>
          <el-input v-model="form.bankAccountName" placeholder="请输入账户名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="开户支行" required>
          <el-input v-model="form.openBranchName" placeholder="请输入开户支行" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="开户支行联行号" required>
          <el-input v-model="form.unionBankNumber" placeholder="请输入开户支行联行号" maxlength="12" show-word-limit />
        </el-form-item>
        <!-- <el-form-item label="交易代码" required>
          <el-input v-model="form.requestType" placeholder="请输入交易代码" maxlength="7" show-word-limit />
        </el-form-item> -->
        <!-- <el-form-item label="请求流水号" required>
          <el-input v-model="form.requestId" placeholder="请输入请求流水号" maxlength="50" show-word-limit />
        </el-form-item> -->
        <el-form-item label="商户编码" required>
          <el-input v-model="form.merchantCode" placeholder="请输入商户编码" maxlength="20" show-word-limit />
        </el-form-item>
        <!-- <el-form-item label="第三方标识" required>
          <el-input v-model="form.userIdIdentity" placeholder="请输入第三方标识，只能输入数字和字母" maxlength="50" show-word-limit />
        </el-form-item> -->
        <el-form-item label="平台服务费" required>
          <el-input v-model="form.platformServiceFee" placeholder="请输入平台服务费" maxlength="13" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            大于等于0，小于等于100。格式为整数+2位小数 例如：100.00
          </div>
        </el-form-item>
        <!-- <el-form-item label="通知地址" required>
          <el-input v-model="form.noticeUrl" placeholder="请输入通知地址" maxlength="250" show-word-limit />
        </el-form-item>
        <el-form-item label="审核通知地址" required>
          <el-input v-model="form.auditNoticeUrl" placeholder="请输入审核通知地址" maxlength="250" show-word-limit />
        </el-form-item> -->
        
        <!-- 文件上传 -->
        <el-form-item label="营业执照照片" required>
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'businessLicensePicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.businessLicensePicture ? [{name: '营业执照照片', url: form.businessLicensePicture}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>
        </el-form-item>
    
        <el-form-item label="法人身份证人像面" required>
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'legalPersonIdCardFrontPicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.legalPersonIdCardFrontPicture ? [{name: '法人身份证人像面', url: form.legalPersonIdCardFrontPicture}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>
        </el-form-item>
        
        <el-form-item label="法人身份证国徽面" required>
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'legalPersonIdCardBackPicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.legalPersonIdCardBackPicture ? [{name: '法人身份证国徽面', url: form.legalPersonIdCardBackPicture}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>
        </el-form-item>
        
        <!-- 受益人信息（选输） -->
        <el-form-item label="受益人姓名">
          <el-input v-model="form.beneficiaryName" placeholder="请输入受益人姓名" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="受益人身份证号码">
          <el-input v-model="form.beneficiaryIdNumber" placeholder="请输入受益人身份证号码" maxlength="18" show-word-limit />
        </el-form-item>
        <el-form-item label="受益人身份证起始日期">
          <el-input v-model="form.beneficiaryIdCardStartDate" placeholder="请输入受益人身份证起始日期，yyyyMMdd" maxlength="8" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            格式：yyyyMMdd，例如：20230101
          </div>
        </el-form-item>
        <el-form-item label="受益人身份证终止日期">
          <el-input v-model="form.beneficiaryIdCardEndDate" placeholder="请输入受益人身份证终止日期，yyyyMMdd" maxlength="8" show-word-limit />
          <div style="font-size: 12px; color: #909399; margin-top: 4px;">
            格式：yyyyMMdd，例如：20230101 ，如果为长期，传20991231
          </div>
        </el-form-item>
        
        <!-- 受益人身份证照片（选输） -->
        <el-form-item label="受益人身份证人像面照片">
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'beneficiaryIdCardFrontPicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.beneficiaryIdCardFrontPicture ? [{name: '受益人身份证人像面', url: form.beneficiaryIdCardFrontPicture}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>
        </el-form-item>
        
        <el-form-item label="受益人身份证国徽面照片">
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'beneficiaryIdCardBackPicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.beneficiaryIdCardBackPictureUrl ? [{name: '受益人身份证国徽面', url: form.beneficiaryIdCardBackPictureUrl}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>



        </el-form-item>
        
        <!-- 行业特殊许可证（选输） -->
        <el-form-item label="行业特殊许可证文件">
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'specialIndustryLicense')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.specialIndustryLicenseUrl ? [{name: '行业特殊许可证', url: form.specialIndustryLicenseUrl}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">文件大小不超过12M</div>
          </el-upload>
        </el-form-item>
        
        <!-- 银行账户证明照片（选输） -->
        <el-form-item label="银行账户证明照片">
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'bankAccountCertificatePicture')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.bankAccountCertificatePictureUrl ? [{name: '银行账户证明', url: form.bankAccountCertificatePictureUrl}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            accept=".png,.jpg,.jpeg"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传png、jpg、jpeg文件，大小不超过2M</div>
          </el-upload>
        </el-form-item>
        
        <!-- 补充资料文件（选输） -->
        <el-form-item label="补充资料文件">
          <el-upload
            class="upload-demo"
            action="/admin/merchant/uploadFileFun"
            :on-change="(file, fileList) => handleFileUpload(file, fileList, 'supplementFile')"
            :auto-upload="false"
            :limit="1"
            :file-list="form.supplementFileUrl ? [{name: '补充资料', url: form.supplementFileUrl}] : []"
            :show-file-list="true"
            :on-preview="(file) => handlePreview(file)"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">文件大小不超过12M</div>
          </el-upload>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交进件</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import regionData from '@/wd/region-data.js'

export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      // 省市区数据
      regionData: regionData,
      // 选中的省市区编码
      selectedRegion: [],
      // 银行列表
      bankList: [
        { label: '青岛银行', value: 'qdb' },
        { label: '青海银行', value: 'qhb' },
        { label: '齐鲁银行', value: 'qlb' },
        { label: '齐商银行', value: 'qsb' },
        { label: '泉州银行', value: 'qzb' },
        { label: '日照银行', value: 'rzb' },
        { label: '山东农信联', value: 'sdcu' },
        { label: '上海农商行', value: 'shrb' },
        { label: '商丘商业银行', value: 'sqcb' },
        { label: '上饶银行', value: 'srb' },
        { label: '绍兴银行', value: 'sxb' },
        { label: '深圳福田银座', value: 'szftyzb' },
        { label: '深圳农商行', value: 'szrb' },
        { label: '苏州银行', value: 'szb' },
        { label: '泰安商业银行', value: 'tacb' },
        { label: '天津农村银行', value: 'tjrb' },
        { label: '天津银行', value: 'tjb' },
        { label: '台州银行', value: 'tzb' },
        { label: '潍坊银行', value: 'wfb' },
        { label: '威海商业银行', value: 'whcb' },
        { label: '吴江农商行', value: 'wjrb' },
        { label: '乌鲁木齐商业银行', value: 'wlmqcb' },
        { label: '温州银行', value: 'wzb' },
        { label: '厦门银行', value: 'xmb' },
        { label: '邢台银行', value: 'xtb' },
        { label: '营口银行', value: 'ykb' },
        { label: '云南农信联', value: 'yncu' },
        { label: '烟台银行', value: 'ytb' },
        { label: '自贡商业银行', value: 'zgcb' },
        { label: '珠海华润银行', value: 'zhhrb' },
        { label: '张家港农商行', value: 'zjgrb' },
        { label: '张家口商业银行', value: 'zjkcb' },
        { label: '浙江景宁银座', value: 'zjjnyzb' },
        { label: '浙江民泰银行', value: 'zjmtcb' },
        { label: '浙江三门银座', value: 'zjsmyzb' },
        { label: '浙江农信联', value: 'zjcu' },
        { label: '浙江泰隆银行', value: 'zjtlcb' },
        { label: '浙江稠州银行', value: 'zjczcb' },
        { label: '浙商银行', value: 'zsb' },
        { label: '郑州银行', value: 'zzb' },
        { label: '重庆农村商业银行', value: 'cqrcb' },
        { label: '中国建设银行', value: 'ccb' },
        { label: '兴业银行', value: 'cib' },
        { label: '中国民生银行', value: 'cmsb' },
        { label: '华夏银行', value: 'hxb' },
        { label: '北京农商行', value: 'rcb' },
        { label: '中国农业银行', value: 'abc' },
        { label: '中国银行', value: 'boc' },
        { label: '中国光大银行', value: 'ceb' },
        { label: '招商银行', value: 'cmb' },
        { label: '农信银中心', value: 'nongxinyin' },
        { label: '中国工商银行', value: 'icbc' },
        { label: '浦发银行', value: 'spdb' },
        { label: '交通银行', value: 'comm' },
        { label: '宁波银行', value: 'nbcb' },
        { label: '中信银行', value: 'cncb' },
        { label: '农村信用合作社', value: 'nxs' },
        { label: '上海银行', value: 'shb' },
        { label: '重庆银行', value: 'cqb' },
        { label: '广发银行', value: 'cgb' },
        { label: '平安银行', value: 'pab' },
        { label: '中国邮政储蓄', value: 'psbc' },
        { label: '渤海银行', value: 'cbhb' },
        { label: '南京银行', value: 'njcb' },
        { label: '恒丰银行', value: 'egb' },
        { label: '北京银行', value: 'bjb' },
        { label: '新网银行', value: 'xwbank' },
        { label: '新安银行', value: 'xab' },
        { label: '农信银青隆村镇银行', value: 'qlrcb' },
        { label: '济南农商行', value: 'jinrb' },
        { label: '海口联合农村商业银行', value: 'hkub' },
        { label: '无锡农商行', value: 'wxrb' },
        { label: '内蒙古自治区农村信用联合社', value: 'nmgcu' },
        { label: '湖南银行', value: 'hrxjb' },
        { label: '贵州银行', value: 'gzeb' },
        { label: '丰城顺银村镇银行', value: 'fcsyb' },
        { label: '山西省农村信用社联合社', value: 'sxecu' },
        { label: '武汉众邦银行', value: 'whzbyh' },
        { label: '网商银行', value: 'myb' },
        { label: '四川天府银行', value: 'cgnb' },
        { label: '天津滨海农信银', value: 'bhrcb' },
        { label: '江南农商行', value: 'jnrb' },
        { label: '江阴农商行', value: 'jyrb' },
        { label: '丹东银行', value: 'ddb' },
        { label: '抚顺银行', value: 'fsb' },
        { label: '辽宁农信联', value: 'lnrb' },
        { label: '盛京银行', value: 'sjb' },
        { label: '武汉农商行', value: 'whrb' },
        { label: '天津滨海农商行', value: 'tjbhrb' },
        { label: '金华银行', value: 'jhb' },
        { label: '湖南农信联', value: 'hnrb' },
        { label: '中原银行', value: 'zyb' },
        { label: '四川农信联', value: 'sccu' },
        { label: '贵州农信联', value: 'gzcu' },
        { label: '陕西农信联', value: 'sxcu' },
        { label: '西安银行', value: 'xianb' },
        { label: '衡水银行', value: 'hengsb' },
        { label: '云南红塔银行', value: 'ynhtb' },
        { label: '江西农信联', value: 'jxcu' },
        { label: '九江银行', value: 'jjb' },
        { label: '甘肃农信联', value: 'gscu' },
        { label: '青海农信联', value: 'qhcu' },
        { label: '新疆农信联', value: 'xjcu' },
        { label: '甘肃银行', value: 'gsb' },
        { label: '黑龙江省农村信用社联合社', value: 'hljcu' },
        { label: '广东省农村信用社联合社', value: 'gdcu' },
        { label: '河北省农村信用社联合社', value: 'hebcu' },
        { label: '湖南岳阳农村商业银行', value: 'hnyyrcb' },
        { label: '江西银行', value: 'jxbank' },
        { label: '厦门国际银行', value: 'xib' },
        { label: '成都银行', value: 'bocd' },
        { label: '鄂托克前旗农村商业银行', value: 'eqqnsyh' },
        { label: '安徽农信联', value: 'ahcu' },
        { label: '鞍山商业银行', value: 'ascb' },
        { label: '北京顺义银座', value: 'bjsyyzb' },
        { label: '包商银行', value: 'bsb' },
        { label: '长安银行', value: 'cab' },
        { label: '承德银行', value: 'cdb' },
        { label: '重庆黔江银座', value: 'cqqjyzb' },
        { label: '重庆渝北银座', value: 'cqybyzb' },
        { label: '长沙银行', value: 'csb' },
        { label: '沧州银行', value: 'czb' },
        { label: '东莞银行', value: 'dgb' },
        { label: '东莞农商行', value: 'dgrb' },
        { label: '大连银行', value: 'dlb' },
        { label: '东营商业银行', value: 'dycb' },
        { label: '德州银行', value: 'dzb' },
        { label: '鄂尔多斯银行', value: 'ordb' },
        { label: '富滇银行', value: 'kmcb' },
        { label: '福建海峡银行', value: 'fjhxb' },
        { label: '福建农信联', value: 'fjcu' },
        { label: '佛山顺德农商行', value: 'fssdrb' },
        { label: '阜新银行', value: 'fxb' },
        { label: '广东华兴银行', value: 'gdhxb' },
        { label: '广东南粤银行', value: 'gdnyb' },
        { label: '桂林银行', value: 'glb' },
        { label: '广西北部湾银行', value: 'gxbbwb' },
        { label: '广西农信联', value: 'gxzzcu' },
        { label: '贵阳商业银行', value: 'gycb' },
        { label: '广州银行', value: 'gzb' },
        { label: '广州农商行', value: 'gzrb' },
        { label: '赣州银行', value: 'jxgzb' },
        { label: '河北银行', value: 'hbb' },
        { label: '湖北农信联', value: 'hbcu' },
        { label: '邯郸商业银行', value: 'hdcb' },
        { label: '哈尔滨银行', value: 'harbb' },
        { label: '汉口银行', value: 'hkb' },
        { label: '葫芦岛银行', value: 'hldb' },
        { label: '海南农信联', value: 'hncu' },
        { label: '徽商银行', value: 'hsb' },
        { label: '杭州银行', value: 'hzb' },
        { label: '湖州银行', value: 'huzb' },
        { label: '吉林银行', value: 'jlb' },
        { label: '吉林农信联', value: 'jlcu' },
        { label: '济宁银行', value: 'jnb' },
        { label: '江苏常熟农商行', value: 'jscsrb' },
        { label: '江苏农信联', value: 'jscu' },
        { label: '江苏银行', value: 'jsb' },
        { label: '晋商银行', value: 'sxjsb' },
        { label: '江西赣州银座', value: 'jxgzyzb' },
        { label: '嘉兴银行', value: 'jxb' },
        { label: '锦州银行', value: 'jzb' },
        { label: '昆仑银行', value: 'klb' },
        { label: '昆山农商行', value: 'ksrb' },
        { label: '廊坊银行', value: 'lfb' },
        { label: '龙江银行', value: 'ljb' },
        { label: '莱商银行', value: 'lsb' },
        { label: '临商银行', value: 'lycb' },
        { label: '兰州银行', value: 'lzb' },
        { label: '柳州银行', value: 'gxlzb' },
        { label: '绵阳商业银行', value: 'mycb' },
        { label: '鄞州农行', value: 'nbyzrb' },
        { label: '内蒙古银行', value: 'nmgb' },
        { label: '宁夏黄河农商行', value: 'nxhhrb' },
        { label: '宁夏银行', value: 'nxb' },
        { label: '河南省农村信用社联合社', value: 'hencu' },
        { label: '宁乡农商银行', value: 'hnnxrb' },
        { label: '淄博博山农商行', value: 'zbbsxrb' },
        { label: '湖北银行', value: 'hbhb' },
        { label: '连云港东方农村商业银行', value: 'lygdfrcb' },
        { label: '中邮邮惠万家银行', value: 'psbcub' },
        { label: '中信百信银行', value: 'aibank' },
        { label: '前海微众银行', value: 'webank' },
        { label: '天津金城银行', value: 'kcb' },
        { label: '上海华瑞银行', value: 'shhrb' },
        { label: '温州民商银行', value: 'wzmsb' },
        { label: '重庆富民银行', value: 'fb' },
        { label: '福建华通银行', value: 'oneb' },
        { label: '江苏苏宁银行', value: 'suningb' },
        { label: '威海蓝海银行', value: 'bob' },
        { label: '辽宁振兴银行', value: 'newupb' },
        { label: '吉林亿联银行', value: 'yilion' },
        { label: '梅州客商银行', value: 'kshb' },
        { label: '北京中关村银行', value: 'zhgcb' },
        { label: '湖南三湘银行', value: 'csxb' },
        { label: '江西裕民银行', value: 'ymb' },
        { label: '无锡锡商银行', value: 'wxsb' },
        { label: '重庆三峡银行', value: 'ccqtgb' },
        { label: '长城华西银行', value: 'gwb' },
        { label: '枣庄银行', value: 'zzhb' },
        { label: '宜宾市商业银行', value: 'ybccb' },
        { label: '雅安市商业银行', value: 'yaccb' },
        { label: '新疆银行', value: 'xjb' },
        { label: '新疆汇和银行', value: 'hhb' },
        { label: '西藏银行', value: 'xzb' },
        { label: '乌海银行', value: 'whb' },
        { label: '铁岭银行', value: 'tlb' },
        { label: '唐山银行', value: 'bots' },
        { label: '遂宁银行', value: 'snccb' },
        { label: '四川银行', value: 'scb' },
        { label: '石嘴山银行', value: 'szsccb' },
        { label: '山西银行', value: 'shxb' },
        { label: '曲靖市商业银行', value: 'qjccb' },
        { label: '秦皇岛银行', value: 'qhdb' },
        { label: '盘锦银行', value: 'pjb' },
        { label: '宁波通商银行', value: 'nbtscb' },
        { label: '宁波东海银行', value: 'ndhb' },
        { label: '蒙商银行', value: 'msb' },
        { label: '泸州银行', value: 'lzccb' },
        { label: '辽沈银行', value: 'lshb' },
        { label: '乐山市商业银行', value: 'lsccb' },
        { label: '库尔勒银行', value: 'xjkccb' },
        { label: '江苏长江商业银行', value: 'cjccb' },
        { label: '海南银行', value: 'hnb' },
        { label: '哈密市商业银行', value: 'hmccb' },
        { label: '达州银行', value: 'dzccb' },
        { label: '朝阳银行', value: 'cycb' },
        { label: '本溪银行', value: 'bxb' },
        { label: '保定银行', value: 'bdb' },
        { label: '其他农商行/农信社', value: 'qtnxs' },
        { label: '外资银行', value: 'wzyh' }
      ],
      tform: {
        // 基本信息
        name: "枝江市娆确科技有限公司",
        enterpriseType: "0", // 
        enterpriseName: "枝江市娆确科技有限公司",
        enterpriseShortName: "枝江市娆确科技有限公司",
        unifiedSocialCreditCode: "91420583MAK5DQGF46",
        businessScope: "一般项目:软件开发，人工智能基础软件开发，日用百货销售，汽车零配件零售，日用家电零售，服装服饰零售，工艺美术品及收藏品零售(象牙及其制品除外)，体育用品及器材零售，照相器材及望远镜零售，自行车及零配件零售，办公用品销售，乐器零售，鞋帽零售，摩托车及零配件零售，劳动保护用品销售，五金产品零售，文具用品零售，化妆品零售，宠物食品及用品零售，厨具卫具及日用杂品零售，家用视听设备销售，家具零配件销售，钟表销售，计算机软硬件及辅助设备零售，自行车零配件销售，日用品销售，乐器零配件销售，照相机及器材销售，照明器具销售，日用杂品销售，家具销售，通信设备销售设材的隐形眼镜)，卫生洁具销售，农副产品销售，户外用品销售，茶具销售，玩具、动漫及游艺用品销售，母婴用品销售，礼品花卉销售，个人卫生用品销售，针纺织品销售。(除许可业务外，可自主依法经营法律法规非禁止或限制的项目)",
        
        // 地址信息
        addressProvinceAreaCode: "420000", 
        addressCityAreaCode: "420500",
        addressDistrictAreaCode: "420583", 
        address: "马家店街道东湖大道28-1号1栋电商产业园1105室",
        
        // 法人信息
        legalPersonName: "鲁秋兰",
        legalPersonIdNumber: "513401197810140228",
        legalPersonMobilePhone: "17765381015",
        legalPersonIdCardStartDate: "20090227",
        legalPersonIdCardEndDate: "20290227",
        
        // 联系人信息
        linkmanName: "高天玉",
        linkmanMobilePhone: "13886201856",
        customerServicePhone: "19871247492",
        
        // 银行信息
        bankCode: "myb", 
        bankCardType: "0", 
        bankAccount: "8888888867067785",
        bankAccountName: "枝江市娆确科技有限公司",
        openBranchName: "浙江网商银行",
        unionBankNumber: "323331000001",
        
        // 交易信息
        requestType: "IMRU015",
        requestId: "",
        merchantCode: "4330000458",
        userIdIdentity: "",
        
        // 费用信息
        platformServiceFee: "100.00", 
        
        // 通知地址
        noticeUrl: "https://www.test.com/api/notice",
        auditNoticeUrl: "https://www.test.com/api/audit-notice",
        
        // 受益人信息（选输）
        beneficiaryName: "",
        beneficiaryIdNumber: "",
        beneficiaryIdCardStartDate: "",
        beneficiaryIdCardEndDate: "",
        
        // 文件上传相关（这里只添加文件名，实际使用中会有文件对象）
        businessLicensePicture: "https://sf.iiar.cn/uploads/697b21d9515ec.png",
        businessLicensePictureName: "697b21d9515ec.png",
        legalPersonIdCardFrontPicture: "https://sf.iiar.cn/uploads/697b22707c616.png",
        legalPersonIdCardFrontPictureName: "697b22707c616.png",
        legalPersonIdCardBackPicture: "https://sf.iiar.cn/uploads/697b22a23016f.png",
        legalPersonIdCardBackPictureName: "697b22a23016f.png",  
        beneficiaryIdCardFrontPicture: "",
        beneficiaryIdCardFrontPictureName: "",
        beneficiaryIdCardBackPicture: "",
        beneficiaryIdCardBackPictureName: "",
        specialIndustryLicense: "",
        specialIndustryLicenseName: "",
        bankAccountCertificatePicture: "",
        bankAccountCertificatePictureName: "",
        supplementFile: "",
        supplementFileName: "",
      },
      form: {
        // 基本信息
        name: "",
        enterpriseType: "",
        enterpriseName: "",
        enterpriseShortName: "",
        unifiedSocialCreditCode: "",
        businessScope: "",
        
        // 地址信息
        addressProvinceAreaCode: "",
        addressCityAreaCode: "",
        addressDistrictAreaCode: "",
        address: "",
        
        // 法人信息
        legalPersonName: "",
        legalPersonIdNumber: "",
        legalPersonMobilePhone: "",
        legalPersonIdCardStartDate: "",
        legalPersonIdCardEndDate: "",
        
        // 联系人信息
        linkmanName: "",
        linkmanMobilePhone: "",
        customerServicePhone: "",
        
        // 银行信息
        bankCode: "",
        bankCardType: "0",
        bankAccount: "",
        bankAccountName: "",
        openBranchName: "",
        unionBankNumber: "",
        
        // 交易信息
        requestType: "IMRU015",
        requestId: "",
        merchantCode: "",
        userIdIdentity: "",
        
        // 费用信息
        platformServiceFee: "",
        
        // 通知地址
        noticeUrl: "",
        auditNoticeUrl: "",
        
        // 受益人信息（选输）
        beneficiaryName: "",
        beneficiaryIdNumber: "",
        beneficiaryIdCardStartDate: "",
        beneficiaryIdCardEndDate: "",
        
        // 文件上传相关
        businessLicensePicture: null,
        businessLicensePictureName: "",
        legalPersonIdCardFrontPicture: null,
        legalPersonIdCardFrontPictureName: "",
        legalPersonIdCardBackPicture: null,
        legalPersonIdCardBackPictureName: "",
        beneficiaryIdCardFrontPicture: null,
        beneficiaryIdCardFrontPictureName: "",
        beneficiaryIdCardBackPicture: null,
        beneficiaryIdCardBackPictureName: "",
        specialIndustryLicense: null,
        specialIndustryLicenseName: "",
        bankAccountCertificatePicture: null,
        bankAccountCertificatePictureName: "",
        supplementFile: null,
        supplementFileName: "",
      }
    };
  },
  computed: {},
  // 页面挂载完成
  mounted() {
    // 初始化选中的地区
    this.selectedRegion = [
      this.form.addressProvinceAreaCode,
      this.form.addressCityAreaCode,
      this.form.addressDistrictAreaCode
    ].filter(Boolean);
    
    // 检查是否有id参数，如有则加载详情
    this.checkForMerchantId();
  },
  methods: {
    // 检查URL参数中的商户id
    checkForMerchantId() {
      const merchantId = this.$route.query.id;
      if (merchantId) {
        this.loadMerchantDetails(merchantId);
      }
    },
    // 加载商户详情
    loadMerchantDetails(merchantId) {
      this.$http_get(`/admin/merchant/detail?id=${merchantId}`, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.form = { ...this.form, ...res.data };
          // 更新地区选择
          this.selectedRegion = [
            this.form.addressProvinceAreaCode,
            this.form.addressCityAreaCode,
            this.form.addressDistrictAreaCode
          ].filter(Boolean);
        } else {
          this.$message.error(res.msg || '加载详情失败');
        }
      }).catch(err => {
        this.$message.error('网络错误');
        console.error('加载商户详情失败:', err);
      });
    },
    // 处理地区选择变化
    handleRegionChange(value) {
      if (value && value.length === 3) {
        this.form.addressProvinceAreaCode = value[0];
        this.form.addressCityAreaCode = value[1];
        this.form.addressDistrictAreaCode = value[2];
      } else {
        this.form.addressProvinceAreaCode = '';
        this.form.addressCityAreaCode = '';
        this.form.addressDistrictAreaCode = '';
      }
    },
    // 提交进件
    submitForm() {
      console.log(this.form);
      // 基本信息验证
      if (!this.form.name) {
        this.$message.warning("请输入商户名称");
        return;
      }
      if (!this.form.enterpriseName) {
        this.$message.warning("请输入企业名称");
        return;
      }
      if (!this.form.enterpriseShortName) {
        this.$message.warning("请输入企业简称");
        return;
      }
      if (!this.form.unifiedSocialCreditCode) {
        this.$message.warning("请输入统一社会信用代码");
        return;
      }
      
      // 地址信息验证
      if (!this.form.addressProvinceAreaCode) {
        this.$message.warning("请输入地址省份编码");
        return;
      }
      if (!this.form.addressCityAreaCode) {
        this.$message.warning("请输入地址城市编码");
        return;
      }
      if (!this.form.addressDistrictAreaCode) {
        this.$message.warning("请输入地址区县编码");
        return;
      }
      if (!this.form.address) {
        this.$message.warning("请输入详细地址");
        return;
      }
      
      // 法人信息验证
      if (!this.form.legalPersonName) {
        this.$message.warning("请输入法人姓名");
        return;
      }
      if (!this.form.legalPersonIdNumber) {
        this.$message.warning("请输入法人身份证号码");
        return;
      }
      if (this.form.legalPersonIdNumber.length !== 18) {
        this.$message.warning("法人身份证号码长度必须为18位");
        return;
      }
      if (!this.form.legalPersonMobilePhone) {
        this.$message.warning("请输入法人手机号");
        return;
      }
      if (this.form.legalPersonMobilePhone.length !== 11) {
        this.$message.warning("法人手机号长度必须为11位");
        return;
      }
      if (!this.form.legalPersonIdCardStartDate) {
        this.$message.warning("请输入法人身份证起始日期");
        return;
      }
      if (!this.form.legalPersonIdCardEndDate) {
        this.$message.warning("请输入法人身份证终止日期");
        return;
      }
      
      // 联系人信息验证
      if (!this.form.linkmanName) {
        this.$message.warning("请输入商务联系人姓名");
        return;
      }
      if (!this.form.linkmanMobilePhone) {
        this.$message.warning("请输入商务联系人手机号");
        return;
      }
      if (this.form.linkmanMobilePhone.length !== 11) {
        this.$message.warning("商务联系人手机号长度必须为11位");
        return;
      }
      if (!this.form.customerServicePhone) {
        this.$message.warning("请输入客服电话");
        return;
      }
      
      // 受益人信息验证（如果有填写）
      if (this.form.beneficiaryIdNumber && this.form.beneficiaryIdNumber.length !== 18) {
        this.$message.warning("受益人身份证号码长度必须为18位");
        return;
      }
      
      // 银行信息验证
      if (!this.form.bankCode) {
        this.$message.warning("请输入结算银行编码");
        return;
      }
      if (!this.form.bankAccount) {
        this.$message.warning("请输入结算银行账号");
        return;
      }
      if (!this.form.bankAccountName) {
        this.$message.warning("请输入结算银行账户名称");
        return;
      }
      if (!this.form.openBranchName) {
        this.$message.warning("请输入开户支行名");
        return;
      }
      if (!this.form.unionBankNumber) {
        this.$message.warning("请输入开户支行联行号");
        return;
      }
      
      // 交易信息验证
      // if (!this.form.requestType) {
      //   this.$message.warning("请输入交易代码");
      //   return;
      // }
      // if (!this.form.requestId) {
      //   this.$message.warning("请输入请求流水号");
      //   return;
      // }
      // if (!this.form.merchantCode) {
      //   this.$message.warning("请输入商户编码");
      //   return;
      // }
      // if (!this.form.userIdIdentity) {
      //   this.$message.warning("请输入第三方标识");
      //   return;
      // }
      
      // 费用信息验证
      if (!this.form.platformServiceFee) {
        this.$message.warning("请输入平台服务费");
        return;
      }
      
      // 通知地址验证
      // if (!this.form.noticeUrl) {
      //   this.$message.warning("请输入开户异步通知地址");
      //   return;
      // }
      // if (!this.form.auditNoticeUrl) {
      //   this.$message.warning("请输入审核异步通知地址");
      //   return;
      // }
      
      // 文件上传验证
      if (!this.form.businessLicensePicture) {
        this.$message.warning("请上传营业执照照片");
        return;
      }
      if (!this.form.legalPersonIdCardFrontPicture) {
        this.$message.warning("请上传法人身份证人像面照片");
        return;
      }
      if (!this.form.legalPersonIdCardBackPicture) {
        this.$message.warning("请上传法人身份证国徽面照片");
        return;
      }
      this.form.id = this.$route.query.id || "";
      this.$http_post("/admin/merchant/create", this.form, 1).then(res => {
        if (res && res.code === 200) {
          this.goBack();
        }
      });
    },
    // 文件上传处理
    handleFileUpload(file, fileList, field) {
      const formData = new FormData();
      formData.append('file', file.raw);
      
      this.$http_post("/admin/merchant/uploadFileFun", formData, 1).then(res => {
        if (res && res.code === 200 && res.data) {
          this.form[field+'Name'] = res.data.file_name ;
          this.form[field] = res.data.filePath || res.data.url || res.data.path || res.data;
          this.$message.success("文件上传成功");
        } else {
          this.$message.error("文件上传失败");
        }
      }).catch(() => {
        this.$message.error("文件上传失败");
      });
    },
    // 文件预览处理
    handlePreview(file) {
      // 预览文件
      window.open(file.url, '_blank');
    },
    // 返回列表
    goBack() {
      this.$router.push("/onboarding");
    }
  }
};
</script>
